import { useQuery } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';
import { dealTransformer } from 'modules/account/sales/transformer';

import c from '../utils/constants';

interface PAYLOAD {
  leadId?: string;
  companyId?: string;
}

export default function useGetDeals(params: PAYLOAD) {
  const { state } = useProvider();
  const { accountId, accountUserId } = useAdminParams();
  const args = state;

  return useQuery({
    queryKey: [c.DEALS, params],
    queryFn: async () => {
      const api = new Api(args);

      const data: ReturnType<typeof dealTransformer.dealsList> = await api.get(
        await withAcl({
          account: {
            url: 'api/v1/sales/deals',
            params: { ...params, include: ['stage'] },
            transformer: dealTransformer.dealsList,
          },
          admin: {
            url: `api/v2/accounts/${accountId}/users/${accountUserId}/sales/deals`,
            params: { ...params, include: ['stage'] },
            transformer: dealTransformer.dealsList,
          },
        }),
      );

      return data;
    },
  });
}
